<template>
  <div>
    <div class="number__routenumbers">
      <div class="route-list">
        <div v-show="busy" class="lds-ripple">
          <div></div>
          <div></div>
        </div>
        <div
          v-show="!busy"
          class="route-container"
          v-for="cartItem in $store.getters.numbersCart"
          :key="cartItem.number"
        >
          <label :for="cartItem.number" class="route-label">{{
            cartItem.number
          }}</label>
          <input
            :id="cartItem.number"
            :value="cartItem.route"
            @keyup="setCartRoute(cartItem.number, $event)"
            :class="{ invalid: !cartItem.valid && $store.getters.submitted }"
            class="route-field"
            placeholder="e.g: 07712 354 678"
          />
        </div>
      </div>
      <p class="desc-text">
        You can change where your number routes to as often as you like.
      </p>
      <hr />
    </div>
  </div>
</template>
<script>
import NumberService from "@/services/NumberService.js";

export default {
  mounted() {
    this.refreshCart();
  },
  data() {
    return {
      busy: false,
    };
  },
  methods: {
    setCartRoute(number, event) {
      const routeTo = event.target.value;

      this.$store.commit("setNumberRoute", { number: number, route: routeTo });
    },
    refreshCart() {
      this.busy = true;
      NumberService.getBasket(this.$store.getters.receipt).then((result) => {
        this.$store.commit("refreshCart", result.data);
        this.busy = false;
        if(this.$store.getters.numbersCart.length < 1){
          const numberType = this.$store.getters.numberType;
          this.$router.push({
            name: "NumberSelector",
            params: { routeNumberType: numberType },
          });
        }
      });
    },
  },
  computed: {},
};
</script>
<style>
</style>